(function () {
  var CART_PATH_RE = /\/cart\/(?:add|change|update)(?:\.js)?/;
  var normalizing = false;
  var pendingTimer = null;

  function rootPath(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/$/, '') + path;
  }

  function textIncludesOpenBox(value) {
    var text = String(value || '').toLowerCase();
    return text.indexOf('open box') !== -1 || text.indexOf('open-box') !== -1 || text.indexOf('openbox') !== -1;
  }

  function itemHasOpenBoxProperty(item) {
    var props = item && item.properties;
    if (!props) return false;
    if (Array.isArray(props)) {
      return props.some(function (prop) {
        return prop && prop.name === '_ck_open_box_limit' && String(prop.value) === 'true';
      });
    }
    return String(props._ck_open_box_limit || '') === 'true';
  }

  function isOpenBoxItem(item) {
    return itemHasOpenBoxProperty(item);
  }

  function isOpenBoxForm(form) {
    if (!form) return false;
    return Boolean(form.querySelector('[name="properties[_ck_open_box_limit]"][value="true"]'));
  }

  function clampInput(input) {
    if (!input) return;
    input.setAttribute('max', '1');
    input.setAttribute('data-ck-open-box-qty', 'true');
    if (String(input.value || '1') !== '1') input.value = '1';
    var wrapper = input.closest('.js-qty__wrapper, quantity-selector, .element-quantity-selector');
    if (wrapper) {
      var plus = wrapper.querySelector('.js-qty__adjust--plus, .element-quantity-selector__button--plus');
      if (plus) {
        plus.setAttribute('disabled', 'disabled');
        plus.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function clampOpenBoxForms() {
    document.querySelectorAll('form[action*="/cart/add"], form.product-single__form').forEach(function (form) {
      if (!isOpenBoxForm(form)) return;
      form.querySelectorAll('input[name="quantity"], input.js-qty__num').forEach(clampInput);
    });

    document.querySelectorAll('.cart__item[data-ck-open-box-line="true"] input.js-qty__num').forEach(clampInput);
  }

  function scheduleNormalize() {
    if (pendingTimer) window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(normalizeCart, 350);
  }

  async function normalizeCart() {
    if (normalizing) return;
    normalizing = true;
    try {
      var response = await window.fetch(rootPath('/cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      var cart = await response.json();
      var openBoxLines = (cart.items || []).filter(function (item) {
        return isOpenBoxItem(item) && Number(item.quantity) > 1;
      });

      for (var i = 0; i < openBoxLines.length; i += 1) {
        await window.fetch(rootPath('/cart/change.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: openBoxLines[i].key, quantity: 1 })
        });
      }

      if (openBoxLines.length) {
        document.dispatchEvent(new CustomEvent('ck:open-box-limit:normalized', {
          detail: { count: openBoxLines.length }
        }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (error) {
      console.warn('Open-box quantity guard could not verify cart quantity.', error);
    } finally {
      normalizing = false;
      clampOpenBoxForms();
    }
  }

  function patchFetch() {
    if (window.__ckOpenBoxLimitFetchPatched || !window.fetch) return;
    window.__ckOpenBoxLimitFetchPatched = true;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function () {
      var request = arguments[0];
      var url = typeof request === 'string' ? request : request && request.url;
      var shouldNormalize = url && CART_PATH_RE.test(url);
      return originalFetch.apply(window, arguments).then(function (response) {
        if (shouldNormalize && !normalizing) scheduleNormalize();
        return response;
      });
    };
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form');
    if (!isOpenBoxForm(form)) return;
    form.querySelectorAll('input[name="quantity"], input.js-qty__num').forEach(clampInput);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ck-open-box-qty="true"]')) return;
    clampInput(input);
    scheduleNormalize();
  }, true);

  document.addEventListener('click', function (event) {
    var plus = event.target && event.target.closest && event.target.closest('.js-qty__adjust--plus, .element-quantity-selector__button--plus');
    if (!plus) return;
    var wrapper = plus.closest('.js-qty__wrapper, quantity-selector, .element-quantity-selector');
    var input = wrapper && wrapper.querySelector('[data-ck-open-box-qty="true"]');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    clampInput(input);
  }, true);

  document.addEventListener('product:added', scheduleNormalize);
  document.addEventListener('cart:updated', scheduleNormalize);
  document.addEventListener('product-form:cart:update', scheduleNormalize);
  document.addEventListener('ajaxProduct:added', scheduleNormalize);

  patchFetch();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      clampOpenBoxForms();
      scheduleNormalize();
    });
  } else {
    clampOpenBoxForms();
    scheduleNormalize();
  }
})();
